export function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
}

/* Creates function matching string fragment case-insensitively */
export function createStringMatcher(filter: string) {
  return (v) =>
    String(v).toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) >= 0
}
